import React from 'react';

import {useModalsContext} from "layouts";
import {STEPS_STATUS} from "utils";

import BazaarCurrentItemConfirmPurchaseModal from "./BazaarCurrentItemConfirmPurchaseModal";
import BazaarCurrentItemCancelListingModal from "./BazaarCurrentItemCancelListingModal";
import BazaarCurrentItemMakeListingModal from "./BazaarCurrentItemMakeListingModal";
import BazaarCurrentItemCancelOfferModal from "./BazaarCurrentItemCancelOfferModal";
import BazaarCurrentItemTransferNFTModal from "./BazaarCurrentItemTransferNFTModal";
import BazaarCurrentItemEditListingModal from "./BazaarCurrentItemEditListingModal";
import BazaarCurrentItemAcceptOfferModal from "./BazaarCurrentItemAcceptOfferModal";
import BazaarCurrentItemOfferModal from "./BazaarCurrentItemOfferModal";

const BazaarCurrentItemModals = () => {
    const {currentModal} = useModalsContext()

    return (
        <React.Fragment>
            {
                {
                    [STEPS_STATUS.LIST_ITEM]: <BazaarCurrentItemMakeListingModal/>,
                    [STEPS_STATUS.CANCEL_OFFER]: <BazaarCurrentItemCancelOfferModal/>,
                    [STEPS_STATUS.ACCEPT_OFFER]: <BazaarCurrentItemAcceptOfferModal/>,
                    [STEPS_STATUS.NFT_TRANSFER]: <BazaarCurrentItemTransferNFTModal/>,
                    [STEPS_STATUS.EDIT_LISTING]: <BazaarCurrentItemEditListingModal/>,
                    [STEPS_STATUS.CANCEL_LISTING]: <BazaarCurrentItemCancelListingModal/>,
                    [STEPS_STATUS.CONFIRM_PURCHASE]: <BazaarCurrentItemConfirmPurchaseModal/>,
                    [STEPS_STATUS.EDIT_OFFER]: <BazaarCurrentItemOfferModal modal={STEPS_STATUS.EDIT_OFFER}/>,
                    [STEPS_STATUS.MAKE_OFFER]: <BazaarCurrentItemOfferModal modal={STEPS_STATUS.MAKE_OFFER}/>,
                }[currentModal.status]
            }
        </React.Fragment>
    )
}

export default BazaarCurrentItemModals